import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { MprcDialogTitleClose, MprcRequestIndicator, MprcText } from "components";
import { ButtonCancel, ButtonJoin } from "components/buttons";
import { AutoCompleteDataModel } from "components/MprcAutoComplete";
import { ChannelAutoCompleteDataModel } from "components/MprcAutoComplete/AutoCompleteDataModel";
import { MprcRequestErrorDialog } from "components/MprcRequestErrorDialog";
import { useSnackbar } from "notistack";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { ManagedChannelAutoComplete } from "views/knowledge/channels/components/ManagedChannelAutoComplete";

////////////////////////////////////////////////////////////////////////////////

interface IPros {
    channelId: string;
    name: string;
    onClose: (channelDestinyId?: string) => void;
}

/////////////////////////////////////////////////////////////////////////////////

export const JoinChannels: React.FC<IPros> = (props) => {

    const { channelId, name, onClose } = props;
    const api = useCoreApi();
    const { t } = useTranslation("knowledge");

    const [saving, setSaving] = useState<boolean>(false);
    const [selectedChannel, setSelectedChannel] = useState<ChannelAutoCompleteDataModel>();
    const [viewError, setViewError] = useState<any>();
    const { enqueueSnackbar } = useSnackbar();


    ////////////////////////////////////////////////////////////////////////////
    /// EFFECT's
    ////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        async function postData() {
            try {
                var result = await api.v1.channelManagement.joinChannel({
                    channelDestinyId: selectedChannel!.key,
                    channelSourceId: channelId
                });

                if (result.data === true) {
                    enqueueSnackbar(t("Channel.List.JoinSuccessMessage"), { variant: "success" });
                    onClose(selectedChannel!.key);
                }
                else {
                    enqueueSnackbar(t("Channel.List.JoinFailMessage"), { variant: "error" });
                }
            }
            catch (e) {
                setViewError(e);
            }
            setSaving(false);
        }

        if (saving) postData();

    }, [saving]);


    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <MprcRequestIndicator
                visible={saving}
            />

            <MprcRequestErrorDialog
                error={viewError}
                onClose={() => setViewError(undefined)}
            />

            <Dialog
                open
                fullWidth
                maxWidth="sm"
                onClose={() => onClose()}
            >
                <MprcDialogTitleClose
                    title={t("Channel.List.JoinTitle")}
                    subtitle={name}
                    onClose={() => onClose()}
                />

                <DialogContent>
                    <Grid container rowSpacing={2}>
                        <ManagedChannelAutoComplete
                            exceptChannelIds={[channelId]}
                            selectedItems={selectedChannel != undefined ? [selectedChannel] : []}
                            onChange={(item: (AutoCompleteDataModel | ChannelAutoCompleteDataModel)[]): void => {
                                if (item.length > 0)
                                    setSelectedChannel(item[0] as ChannelAutoCompleteDataModel);
                                else
                                    setSelectedChannel(undefined);

                            }}
                            placeholder={t("Channel.List.JoinChannelPlaceholder")}
                            helperText={
                                <Trans
                                    i18nKey={t("Channel.List.JoinChannelHint")}
                                    components={{ red: <MprcText color="error" /> }}
                                />
                            }
                            required
                        />
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Grid container rowSpacing={2} m={1} ml={2}>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid size="grow">
                                <Grid container justifyContent="end" alignItems="center" spacing={2} mt={1}>
                                    <Grid>
                                        <ButtonCancel onClick={() => onClose()} variant="contained" />
                                    </Grid>
                                    <Grid>
                                        <ButtonJoin
                                            disabled={selectedChannel == undefined || selectedChannel.key == channelId}
                                            onClick={() => setSaving(true)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
};
